/* Scoped dental funnel controls. Native checkout remains held in commerce config. */
(() => {
  const carry = target => {
    const destination = new URL(target, location.origin), source = new URL(location.href);
    if (destination.origin !== location.origin) return destination.href;
    for (const [key, value] of source.searchParams) {
      if (!['view', 'preview_theme_id', '_fd', 'pb'].includes(key) && !destination.searchParams.has(key)) destination.searchParams.set(key, value);
    }
    return destination.href;
  };
  document.querySelectorAll('[data-dental-funnel-link]').forEach(link => { link.href = carry(link.href); });
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-dental-funnel-target]');
    if (target) { event.preventDefault(); location.assign(carry(target.dataset.dentalFunnelTarget)); return; }
    const anchor = event.target.closest('a');
    if (anchor?.dataset.localLink === 'true') { event.preventDefault(); return; }
    const button = event.target.closest('button');
    if (button && /^share$/i.test(button.textContent.trim())) {
      button.parentElement.classList.toggle('share-open');
      button.setAttribute('aria-expanded', String(button.parentElement.classList.contains('share-open')));
    }
    if (button && /^print$/i.test(button.textContent.trim())) window.print();
  });
  document.addEventListener('submit', event => {
    if (event.target.dataset.localForm === 'true') event.preventDefault();
  });
})();
